import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PageWrapper from "./layout/PageWrapper";
import Button from "./forms/Button";
import { ShieldX, ArrowLeft, LayoutDashboard } from "lucide-react";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);
  const goToDashboard = () => navigate("/main/dashboard", { replace: true });

  return (
    <PageWrapper
      title="Access Denied"
      subtitle="You don't have permission to view this page"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center justify-center min-h-[60vh]"
      >
        <div className="card shadow-lg max-w-md w-full text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.1, duration: 0.3 }}
              className="w-20 h-20 rounded-full bg-gradient-to-br from-primary-accent/20 to-orange-600/20 dark:from-primary-accent/30 dark:to-orange-600/30 flex items-center justify-center border-2 border-primary-accent/30"
            >
              <ShieldX className="w-10 h-10 text-primary-accent" strokeWidth={2} />
            </motion.div>
          </div>

          <h2 className="text-xl font-bold text-gray-900 dark:text-light-100 mb-2">
            Unauthorized
          </h2>
          <p className="text-gray-600 dark:text-light-500 text-sm mb-8">
            You do not have access to the requested page. If you believe this is
            an error, please contact your administrator.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="secondary"
              onClick={goBack}
              icon={<ArrowLeft className="w-4 h-4" />}
              className="flex items-center justify-center gap-2"
            >
              Go Back
            </Button>
            <Button
              variant="primary"
              onClick={goToDashboard}
              icon={<LayoutDashboard className="w-4 h-4" />}
              className="flex items-center justify-center gap-2"
            >
              Dashboard
            </Button>
          </div>
        </div>
      </motion.div>
    </PageWrapper>
  );
};

export default Unauthorized;
